<div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="overlay-pane">
  <div class="dialog-title" mat-dialog-title cdkDragHandle>
    {{'main.help-dialog.title' | translate}}
    <button mat-icon-button mat-dialog-close>
      <fa-icon [icon]="faTimes" size="lg"></fa-icon>
    </button>
  </div>
  <div mat-dialog-content>
    <div [innerHTML]="data.content" class="help-dialog-content"></div>
  </div>
</div>